export const TAGS = {
  TOKEN_CHANGED: 'TOKEN_CHANGED',
  CONSUMER_CART: 'CONSUMER_CART',
};
